<div class="card card-xxl-stretch">

<div class="card-body">
  <div style="width: 100%; display: block; position: relative;  margin: 0 auto; height: 300px;">
    <lottie-player style="position:absolute; max-width: 100%; height: 300px; top:-00px; left: 0; right: 0; margin: auto" autoplay loop src="{{'/assets/lotties/' + loader}}">
    </lottie-player>
  </div>
  <h3 class="text-center fs-2">{{message}}</h3>
</div>
</div>
